// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { StyleSheetManager } from '/app/jenkins/workspace/lmc/web/contract_market_frontend/node_modules/styled-components';

const styledComponentsConfig = {};
export function rootContainer(container) {
  const scConfig =
    typeof styledComponentsConfig === 'function'
      ? styledComponentsConfig()
      : styledComponentsConfig;
  const globalStyle = scConfig.GlobalStyle ? <scConfig.GlobalStyle /> : null;
  const inner = (
    <>
      {globalStyle}
      {container}
    </>
  );
  
  return (
    <StyleSheetManager {...{"disableCSSOMInjection":true}}>
      {inner}
    </StyleSheetManager>
  );
  
}
